import { css } from "@emotion/core";
import {
  fontTypes,
  color,
  fontSizes,
  fontWeight,
} from "../../constants/commons";
export const footerStyle = (isUserLoggedIn: boolean | false) => css`
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .responsive-contact-div {
      display: flex;
      margin: -1em 0 0em 0;
      padding: 0;
    }
    .footer-details-color {
      color: ${color.lightishGray};
      font-weight: ${fontWeight.medium};
    }
    .first-line-footer {
      color: ${color.borderGreen};
      font-size: ${fontSizes.xxlg};
      font-weight: ${fontWeight.bold};
      text-transform: uppercase;
    }
    .second-line-footer {
      color: ${color.lightCement};
      font-size: ${fontSizes.xlg};
      font-weight: ${fontWeight.bold};
      text-transform: uppercase;
    }
    .responsive-margin-footer {
      margin: 4em 0 1em 0;
    }
    .responsive-top-container-footer {
      margin: 4em 0 4em 0;
    }
  }

  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .responsive-contact-div {
      display: flex;
      margin: -1em 0 0em 0;
      padding: 0;
    }
    .footer-details-color {
      color: ${color.lightishGray};
      font-weight: ${fontWeight.medium};
      font-size: ${fontSizes.sm} !important;
    }
    .first-line-footer {
      color: ${color.borderGreen};
      font-size: ${fontSizes.largeFooter};
      font-weight: ${fontWeight.bold};
      text-transform: uppercase;
    }
    .second-line-footer {
      color: ${color.lightCement};
      font-size: ${fontSizes.xxlg};
      font-weight: ${fontWeight.bold};
      text-transform: uppercase;
    }
    .responsive-margin-footer {
      margin: 4em 0 1em 0;
    }
    .responsive-top-container-footer {
      margin: 4em 0 4em 0;
    }
    .responsive-tab-margin {
      margin-bottom: 1.5em;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .first-line-footer {
      color: ${color.borderGreen};
      font-size: ${fontSizes.tabletFooter};
      font-weight: ${fontWeight.bold};
      text-transform: uppercase;
    }
    .footer-details-color {
      color: ${color.lightishGray};
      font-weight: ${fontWeight.medium};
      font-size: ${fontSizes.sm};
    }
    .second-line-footer {
      color: ${color.lightCement};
      font-size: ${fontSizes.large};
      font-weight: ${fontWeight.bold};
      text-transform: uppercase;
    }
    .responsive-contact-div {
      margin: 2em 0 0 0;
      text-align: right;
    }
    .responsive-margin-footer {
      margin: 6em 0 2em 0;
    }
    .responsive-top-container-footer {
      ${isUserLoggedIn ? `margin: 6em 0;` : `margin: 6em 0 0 0;`}
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    margin: 0 3em 0 3m;
    .first-line-footer {
      color: ${color.borderGreen};
      font-size: ${fontSizes.tabletFooter};
      font-weight: ${fontWeight.bold};
      text-transform: uppercase;
    }
    .second-line-footer {
      color: ${color.lightCement};
      font-size: ${fontSizes.large};
      font-weight: ${fontWeight.bold};
      text-transform: uppercase;
    }
    .responsive-contact-div {
      margin: 2em 0 0 0;
      text-align: right;
    }
    .footer-details-color {
      color: ${color.lightishGray};
      font-weight: ${fontWeight.medium};
      font-size: ${fontSizes.sm};
    }
    .responsive-margin-footer {
      margin: 6em 0 2em 0;
    }
    .responsive-top-container-footer {
      ${isUserLoggedIn ? `margin: 6em 0;` : `margin: 6em 0 0 0;`}
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    margin: 0 3em 0 3m;

    .font-bold {
      font-family: ${fontTypes.bold};
    }
    .first-line-footer {
      color: ${color.borderGreen};
      font-size: ${fontSizes.extraLargeFooter};

      text-transform: uppercase;
    }
    .second-line-footer {
      color: ${color.lightCement};
      font-size: ${fontSizes.largeFooter};

      text-transform: uppercase;
    }
    .responsive-contact-div {
      margin: 2em 0 0 0;
      text-align: right;
    }
    .footer-details-color {
      color: ${color.lightishGray};
      font-weight: ${fontWeight.medium};
      font-size: ${fontSizes.sm};
    }
    .responsive-margin-footer {
      margin: 6em 0 2em 0;
    }
    .responsive-top-container-footer {
      ${isUserLoggedIn ? `margin: 6em 0;` : `margin: 6em 0 0 0;`}
    }
  }
`;
